import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import ba from "../assets/images/sidom/svg/Ar.svg";
import { useLocation } from "react-router-dom";
import logo from "../assets/images/icons/sidom.svg";

import ButtonOrange from "../components/ButtonOrang";
export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
  const [isDropdownOpen3, setIsDropdownOpen3] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = (dropdown) => {
    if (dropdown === "dropdown1") {
      setIsDropdownOpen(!isDropdownOpen);
      if (isDropdownOpen2) setIsDropdownOpen2(false);
      if (isDropdownOpen3) setIsDropdownOpen3(false);
    } else if (dropdown === "dropdown2") {
      setIsDropdownOpen2(!isDropdownOpen2);
      if (isDropdownOpen) setIsDropdownOpen(false);
      if (isDropdownOpen3) setIsDropdownOpen3(false);
    } else if (dropdown === "dropdown3") {
      setIsDropdownOpen3(!isDropdownOpen3);
      if (isDropdownOpen) setIsDropdownOpen(false);
      if (isDropdownOpen2) setIsDropdownOpen2(false);
    }
  };
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setIsDropdownOpen2(false);
        setIsDropdownOpen3(false);
      }
    }
    if (isDropdownOpen || isDropdownOpen2 || isDropdownOpen3) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen, isDropdownOpen2, isDropdownOpen3]);

  return (
    <nav className="fixed top-0 left-0 w-full z-50  bg-sidom-light dark:bg-sidom-blue shadow-md">
      <div className="flex flex-wrap justify-between items-center mx-auto  max-w-screen-xl  p-4">
        {/* LOGO */}
        <a
          href="/"
          className="flex items-center space-x-3 logo animate-fade-down animate-once animate-ease-in rtl:space-x-reverse"
        >
          <img src={logo} className="h-6" alt="Logo" />
        </a>

        {/* BOTÓN HAMBURGUESA/X ANIMADO */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          type="button"
          className="inline-flex flex-col items-center justify-center p-2 w-10 h-10 lg:hidden rounded-lg focus:outline-none focus:ring-2 focus:ring-sidom-orange dark:focus:ring-gray-600 z-[102] mb-8"
          aria-controls="navbar-menu"
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú principal"}
        >
          <span className="sr-only">
            {isMenuOpen ? "Cerrar menú" : "Abrir menú principal"}
          </span>
          <span
            className={`block w-6 h-0.5 bg-sidom-dark dark:bg-sidom-light transition-all duration-300 ease-in-out ${
              isMenuOpen ? "rotate-45 translate-y-1" : ""
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-sidom-dark dark:bg-sidom-light transition-all duration-300 ease-in-out my-1 ${
              isMenuOpen ? "opacity-0" : ""
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-sidom-dark dark:bg-sidom-light transition-all duration-300 ease-in-out ${
              isMenuOpen ? "-rotate-45 -translate-y-2" : ""
            }`}
          ></span>
        </button>

        {/* CONTENEDOR MENÚ */}
        <div
          ref={dropdownRef}
          id="navbar-menu"
          className={`${
            isMenuOpen
              ? "flex fixed top-0 left-0 w-full h-full z-[100] bg-sidom-light dark:bg-sidom-blue overflow-y-auto"
              : "hidden"
          } flex-col lg:flex lg:flex-row lg:items-center w-full lg:w-auto gap-4 mt-4 lg:mt-0 transition-all duration-300 ease-in-out`}
        >
          {/* ESPACIADO SUPERIOR PARA SEPARAR CONTENIDO DEL BOTÓN */}
          <div className="h-10 lg:hidden"></div>

          {/* LINKS PRINCIPALES */}
          <ul className="flex flex-col lg:flex-row lg:items-center p-4 lg:p-0  lg:border-none rounded-lg lg:space-x-8 rtl:space-x-reverse text-sidom-dark dark:text-sidom-light w-full lg:w-auto">
            {/* === Dropdown: Soluciones === */}
            <li className="relative">
              <button
                onClick={() => toggleDropdown("dropdown1")}
                className="flex items-center justify-between w-full py-2 px-3 lg:p-0 duration-500 hover:-translate-x-[1px] hover:text-sidom-orange dark:hover:text-sidom-orange lg:hover:bg-transparent "
              >
                Soluciones
                <svg
                  className="w-2 h-2 ml-2"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              {isDropdownOpen && (
                <div
                  className={`z-20  ${
                    isMenuOpen
                      ? "relative w-full mt-2"
                      : "absolute left-0 mt-2 w-full lg:w-[250px] xl:w-[390px] "
                  } bg-sidom-light dark:bg-sidom-blue rounded-lg shadow-sm`}
                >
                  <ul className="py-4 px-2 flex flex-col gap-2 font-medium text-sm text-sidom-orange">
                    {/* Lista de links de soluciones */}
                    <li>
                      <Link
                        to="/#Global-Trade"
                        onClick={() => setIsMenuOpen(false)}
                        className="flex flex-wrap px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 "
                      >
                        <p className="font-bold transition-all duration-500 hover:-translate-x-[1px]">
                          SIDOM Global Trade -
                        </p>
                        <p className="text-sidom-blue dark:text-sidom-light ml-1 transition-all duration-500 hover:-translate-x-[1px]">
                          SUITE Integral
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sidom-smart-reader"
                        onClick={() => setIsMenuOpen(false)}
                        className="flex flex-wrap px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 "
                      >
                        <p className="font-bold transition-all duration-500 hover:-translate-x-[1px]">
                          SIDOM Smart Reader -
                        </p>
                        <p className="text-sidom-blue dark:text-sidom-light ml-1 transition-all duration-500 hover:-translate-x-[1px]">
                          Document Compliance
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sidom-insurance"
                        onClick={() => setIsMenuOpen(false)}
                        className="flex flex-wrap px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 "
                      >
                        <p className="font-bold transition-all duration-500 hover:-translate-x-[1px]">
                          SIDOM Insurance -
                        </p>
                        <p className="text-sidom-blue dark:text-sidom-light ml-1 transition-all duration-500 hover:-translate-x-[1px]">
                          COMEX Insurtech
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pay"
                        onClick={() => setIsMenuOpen(false)}
                        className="flex flex-wrap px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 "
                      >
                        <p className="font-bold transition-all duration-500 hover:-translate-x-[1px]">
                          SIDOM Pay -
                        </p>
                        <p className="text-sidom-blue dark:text-sidom-light ml-1 transition-all duration-500 hover:-translate-x-[1px]">
                          Integración financiera
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sidom-mre"
                        onClick={() => setIsMenuOpen(false)}
                        className="flex flex-wrap px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 "
                      >
                        <p className="font-bold transition-all duration-500 hover:-translate-x-[1px]">
                          SIDOM MRE -
                        </p>
                        <p className="text-sidom-blue dark:text-sidom-light ml-1 transition-all duration-500 hover:-translate-x-[1px]">
                          Regímenes Especiales
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/sidom-misim"
                        onClick={() => setIsMenuOpen(false)}
                        className="flex flex-wrap px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 "
                      >
                        <p className="font-bold transition-all duration-500 hover:-translate-x-[1px]">
                          SIDOM MiSIM -
                        </p>
                        <p className="text-sidom-blue dark:text-sidom-light ml-1 transition-all duration-500 hover:-translate-x-[1px]">
                          Solución Aduanera
                        </p>
                        <img
                          src={ba}
                          alt="AR"
                          className="ml-2 w-5 h-5 rounded-full border"
                        />
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* === Link: Nosotros === */}
            <li>
              <Link
                to="/about"
                className="block py-2 px-3 lg:p-0 hover:text-sidom-orange duration-500 hover:-translate-x-[1px]"
                onClick={() => setIsMenuOpen(false)}
              >
                <p className="duration-500 hover:-translate-x-[1px]">
                  Nosotros
                </p>
              </Link>
            </li>

            {/* === Dropdown: Novedades === */}
            <li className="relative">
              <button
                onClick={() => toggleDropdown("dropdown2")}
                className="flex items-center justify-between w-full py-2 px-3 lg:p-0 hover:text-sidom-orange duration-500 hover:-translate-x-[1px] dark:hover:text-sidom-orange lg:hover:bg-transparent "
              >
                <p className="duration-500 hover:-translate-x-[1px]">
                  Novedades
                </p>

                <svg
                  className="w-2 h-2 ml-2"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              {isDropdownOpen2 && (
                <div
                  className={`z-20 ${
                    isMenuOpen
                      ? "relative w-full mt-2"
                      : "absolute left-0 mt-2 "
                  } bg-sidom-light dark:bg-sidom-blue  rounded-lg shadow-sm`}
                >
                  <ul className="py-2 text-sm font-semibold text-sidom-orange">
                    <li>
                      <Link
                        to="/sidom-eventos"
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600  "
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <p className="duration-500 hover:-translate-x-[1px]">
                          Networking
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/blogs"
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600  "
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <p className="duration-500 hover:-translate-x-[1px]">
                          Notas
                        </p>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://sidom.na.teamtailor.com/"
                        target="_blank"
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600  "
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <p className="duration-500 hover:-translate-x-[1px]">
                          Trabaja con nosotros
                        </p>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* === Link: Acceso === */}
            <li className="relative">
              <a
                href="https://app.sidom.io/index.php/acceso?__hstc=225037893.06f885efb8299a9291cf66d7a74c5fac.1749521486527.1751740127472.1751821284693.14&__hssc=225037893.1.1751821284693&__hsfp=7356485"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between w-full py-2 px-3 lg:p-0 hover:text-sidom-orange duration-500 hover:-translate-x-[1px] dark:hover:text-sidom-orange lg:hover:bg-transparent"
                onClick={() => setIsMenuOpen(false)}
              >
                <p className="duration-500 text-nowrap w-full hover:-translate-x-[1px] ">
                  Acceso a Clientes
                </p>
              </a>
            </li>
            <li>
              <Link
                to="/conocimientopwc"
                className="block py-2 px-3 lg:p-0 hover:text-sidom-orange duration-500 hover:-translate-x-[1px]"
                onClick={() => setIsMenuOpen(false)}
              >
                Conocimiento PwC
              </Link>
            </li>
          </ul>

          {/* BOTÓN DEMO */}
          <div className="flex flex-col lg:flex-row items-center gap-2 w-full lg:w-auto mt-auto lg:mt-0 mb-8 lg:mb-0 fixed bottom-8 left-0 right-0 lg:static justify-center">
            <ButtonOrange
              text="SOLICITAR DEMO"
              link="/contact"
              showLineEffect={false}
              customBackground="bg-sidom-light"
              textColor="text-sidom-light"
              borderColor="border-sidom-orange"
            />
          </div>
        </div>
      </div>
    </nav>
  );
}
